import auth from '~/auth';

import { LE_BUSINESS_TRAVELLER } from '~/consts/businessTraveller';

import { Societe, businessTravellerBasePath, getBusinessSettings } from './BusinessTravellerService';

export async function getDashboardSocieteSettings(businessId: string): Promise<Societe | null> {
  const [defaults, business] = await Promise.all([getBusinessSettings(), getBusinessSettings(businessId)]);
  // Mirrors svc-business getWithDefaults: a business setting overrides the entire default setting.
  return business.societe?.value ?? defaults.societe?.value ?? null;
}

export async function getEmployeeQualifyingOrderCount(
  businessId: string,
  customerId: string,
  signal?: AbortSignal,
): Promise<number> {
  const token = await auth.getAccessToken({ impersonation: { customerId, brand: LE_BUSINESS_TRAVELLER } });
  if (!token) throw new Error('Sign in to load tier progress.');
  const url = `${businessTravellerBasePath()}/businesses/${encodeURIComponent(businessId)}/orders/employee?timeframe=qualificationWindow&filterBy=traveller&limit=1&page=0`;
  // The existing admin token exchange preserves the signed-in admin session. Use the
  // employee token only for this read, matching the traveller portal's qualification request.
  const response = await fetch(url, { headers: { Authorization: `Bearer ${token}` }, credentials: 'omit', signal });
  if (!response.ok) throw new Error(`Unable to load qualifying orders (${response.status}).`);
  const result = await response.json();
  if (!Number.isInteger(result.meta?.total) || result.meta.total < 0)
    throw new Error('Qualifying order count missing from response.');
  return result.meta.total;
}
